import React, { SVGProps } from 'react';

export const ViewEndSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M10.5556 8H2.25' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M10.5556 4.16699H2.25' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M6.72222 11.833H2.25' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M13.7501 4.16699V10.5559C13.7501 10.8948 13.6154 11.2198 13.3758 11.4594C13.1362 11.699 12.8112 11.8337 12.4723 11.8337H9.27783'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5556 10.5557L9.27783 11.8334L10.5556 13.1112'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
